import { AgeGroup, ResolvedPatientGroup } from '~/storm'
import { getAge } from '~/utils/dips/patient'
import { isNotNullish, isNullish } from '~/utils/guards'

import { Patient } from '../transformers/dips-api-type-snapshots/Patient'

function getUnspecifiedAgeGroup<T extends AgeGroup>(ageGroups: T[]): T | undefined {
    return ageGroups.find(group => group.age_group_code === 'unspecified')
}

export const getPatientAgeGroup = <T extends AgeGroup>(patient: Patient | undefined, ageGroups: T[]): T | undefined => {
    const age = getAge(patient)
    if (isNullish(age)) {
        return getUnspecifiedAgeGroup(ageGroups)
    }
    const ageGroup = ageGroups.find(group => {
        if (isNullish(group.minimum_age) && isNullish(group.maximum_age)) return false
        if (isNotNullish(group.minimum_age) && age < group.minimum_age) return false
        if (isNotNullish(group.maximum_age) && age > group.maximum_age) return false
        return true
    })
    // fallback to unspecified age group if no group is found
    return ageGroup ?? getUnspecifiedAgeGroup(ageGroups)
}

export function formatSurgeryTypeGroup(patientGroup: ResolvedPatientGroup): string {
    return patientGroup.surgeryTypeGroup?.display_name ?? ''
}

function compareSurgeryTypeGroups(a?: ResolvedPatientGroup | null, b?: ResolvedPatientGroup | null): number {
    if (isNullish(a) && isNullish(b)) {
        return 0
    }
    if (isNullish(a)) {
        return -1
    }
    if (isNullish(b)) {
        return 1
    }
    return formatSurgeryTypeGroup(a).localeCompare(formatSurgeryTypeGroup(b))
}

export function bySurgeryTypeGroupComparer(a: { patientGroup: ResolvedPatientGroup | null }, b: { patientGroup: ResolvedPatientGroup | null }): number {
    return compareSurgeryTypeGroups(a.patientGroup, b.patientGroup)
}
